export default "__VITE_ASSET__DJ2t4gfi__"